module.exports = __webpack_public_path__ + "static/media/0328_IMG_LE_PRIMEUR.ffb1463f.webp";